import { resetAttribute } from '../handleData'

const home = {
  componentTypes: ['dialogForm'],
  personUser: {
    title: (params) => {
      return params.formValues && params.formValues.editType === 'passwd'
        ? '修改用户密码'
        : params.formValues && params.formValues.editType === 'telphoneNum'
        ? '更换手机号码'
        : params.formValues && params.formValues.editType === 'userName'
        ? '修改用户名称'
        : '修改默认机构'
    },
    editFun: (params) => {
      return params.formValues &&
        (params.formValues.editType === 'passwd' ||
          params.formValues.editType === 'telphoneNum')
        ? 'user/editPassWord'
        : 'user/editPerUserInfo'
    },
    formParams: {
      uid: '',
      userName: '',
      passwd: '',
      currentOrgUid: '',
      telphoneNum: '',
      smsCode: '',
      editType: ''
    },
    formRules: {
      userName: [
        {
          required: (params) => {
            return (
              params.formValues && params.formValues.editType === 'userName'
            )
          },
          message: '请输入用户名',
          trigger: 'blur'
        },
        {
          pattern: /\w{1,18}/,
          message: '用户名必须由字母或数字组成',
          trigger: 'blur'
        }
      ],
      passwd: [
        {
          required: (params) => {
            return params.formValues && params.formValues.editType === 'passwd'
          },
          message: '请输入密码',
          trigger: 'blur'
        },
        {
          min: 8,
          max: 16,
          message: '密码应在长度在 8 到 16 个字符',
          trigger: 'blur'
        }
      ],
      checkPasswd: [
        {
          required: (params) => {
            return params.formValues && params.formValues.editType === 'passwd'
          },
          message: '请再次输入密码',
          trigger: 'blur'
        },
        {
          validator: (params) => {
            return params.formValues && params.formValues.editType === 'passwd'
              ? params.validate.validateCheckPasswd
              : null
          },
          trigger: 'blur'
        }
      ],
      telphoneNum: [
        {
          required: (params) => {
            return (
              params.formValues && params.formValues.editType === 'telphoneNum'
            )
          },
          message: '请输入手机号',
          trigger: 'blur'
        },
        {
          pattern: (params) => {
            return params.formValues &&
              params.formValues.editType === 'telphoneNum'
              ? /^1(3|4|5|6|7|8|9)\d{9}$/
              : null
          },
          message: '手机号码输入不合法',
          trigger: 'blur'
        }
      ],
      currentOrgUid: [
        {
          required: (params) => {
            return (
              params.formValues && params.formValues.editType === 'currentOrg'
            )
          },
          message: '请选择默认机构',
          trigger: 'blur'
        }
      ],
      smsCode: [
        {
          required: (params) => {
            return (
              params.formValues && params.formValues.editType === 'telphoneNum'
            )
          },
          message: '请输入短信验证码',
          trigger: 'blur'
        }
      ]
    },
    formData: [
      {
        key: 'userName',
        label: '用户名称',
        placeholder: '请输入18位以内字母及数字组合用户名',
        type: 'input',
        disabled: (params) => {
          return params.formValues && params.formValues.editType !== 'userName'
        },
        span: 18
      },
      {
        key: 'phoneNum',
        isShow: (params) => {
          return (
            params.formValues && params.formValues.editType === 'telphoneNum'
          )
        },
        label: '旧手机号码',
        type: 'input',
        disabled: true,
        span: 18
      },
      {
        key: 'telphoneNum',
        isShow: (params) => {
          return (
            params.formValues && params.formValues.editType === 'telphoneNum'
          )
        },
        label: '新手机号码',
        type: 'input',
        placeholder: '请输入新手机号码以获取短信验证码',
        span: 18
      },
      {
        key: 'smsCode',
        isShow: (params) => {
          return (
            params.formValues && params.formValues.editType === 'telphoneNum'
          )
        },
        label: '手机验证码',
        type: 'input',
        inputButton: '获取验证码',
        placeholder: '请输入新手机号码接收的短信验证码',
        buttonIcon: 'el-icon-position',
        span: 18
      },
      {
        key: 'currentOrgUid',
        label: '默认登录机构',
        isShow: (params) => {
          return (
            params.formValues && params.formValues.editType === 'currentOrg'
          )
        },
        type: 'select',
        options: (params) => {
          const userRoles = resetAttribute(
            params.state.user.organizations,
            'orgCode',
            'orgUid'
          )
          return userRoles
        },
        checkByValue: true,
        span: 18
      },
      {
        key: 'passwd',
        isShow: (params) => {
          return params.formValues && params.formValues.editType === 'passwd'
        },
        label: '密码',
        type: 'input',
        placeholder: '请输入8至16位字母及数字组合密码',
        inputType: 'password',
        span: 18
      },
      {
        key: 'checkPasswd',
        isShow: (params) => {
          return params.formValues && params.formValues.editType === 'passwd'
        },
        label: '确认密码',
        type: 'input',
        placeholder: '请再次输入修改后密码',
        inputType: 'password',
        span: 18
      }
    ]
  }
}

export default home
